import React, { useState } from "react";
import { Helmet } from "react-helmet";
import FsLightbox from "fslightbox-react";
import "../../../App.css"
import image7 from "../../../Img/Proyectos/ProyectosResidenciales/CasaVP5/61ce0807fb5d267e950f22e2_Casa5.1.jpg"
import image2 from "../../../Img/Proyectos/ProyectosResidenciales/CasaVP5/61ce083c64d162f7960e5569_Casa5.2.jpg"
import image3 from "../../../Img/Proyectos/ProyectosResidenciales/CasaVP5/61ce083c7b30ec89aa31e84b_Casa5.3.jpg"
import image4 from "../../../Img/Proyectos/ProyectosResidenciales/CasaVP5/61ce083cfd2b2256a122e7b0_Casa5.4.jpg"
import image5 from "../../../Img/Proyectos/ProyectosResidenciales/CasaVP5/61ce08297dc00ca05d4fec9b_Casa5.5.jpg"
import image6 from "../../../Img/Proyectos/ProyectosResidenciales/CasaVP5/61ce084eec15b56b2be8b091_Casa5.8.jpg"
import image1 from "../../../Img/Proyectos/ProyectosResidenciales/CasaVP5/61ce084e42c759712fd5cd06_Casa5.10.jpg"
import image8 from "../../../Img/Proyectos/ProyectosResidenciales/CasaVP5/61ce084e7957d30c27f33d14_Casa5.11.jpg"
import image9 from "../../../Img/Proyectos/ProyectosResidenciales/CasaVP5/61ce084e856e7558373e7fac_Casa5.12.jpg"
import image10 from "../../../Img/Proyectos/ProyectosResidenciales/CasaVP5/61ce084d856e753b8b3e7fab_Casa5.13.jpg"
import image11 from "../../../Img/Proyectos/ProyectosResidenciales/CasaVP5/61ce084da6eb89ace44c697f_Casa5.14.jpg"

function ProyectoCasaVP5() {

    const [toggler, setToggler] = useState(false);

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    function openLightboxOnSlide(number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number
        });
    }


    return (
        <>

            <Helmet>
                <title>Residencial - Casa VP 5</title>
            </Helmet>

            <FsLightbox
                toggler={lightboxController.toggler}

                sources={[
                    image1, image2, image3, image4, image5, image6, image7, image8, image9, image10, image11
                ]}

                slide={lightboxController.slide}
            />

            <div className="container col-12 py-5">
                <div className="d-flex">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/proyectos-residenciales">Residenciales</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Casa VP 5</li>
                        </ol>
                    </nav>
                </div>
                <h1 className="py-2 m-0 p-0">Casa VP 5</h1>                
            </div>

            <div className="container position-relative">
                <img onClick={() => openLightboxOnSlide(1)} type="button" src={image1} className="w-100" alt="..." height={650} />
            </div>


            <div className="container">
                <div className="row gy-4 mt-1">

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(2)}
                            src={image2}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(3)}
                            src={image3}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(4)}
                            src={image4}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(5)}
                            src={image5}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(6)}
                            src={image6}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(7)}
                            src={image7}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(8)}
                            src={image8}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(9)}
                            src={image9}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(10)}
                            src={image10}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(11)}
                            src={image11}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                </div>
            </div>
        </>
    );
}

export default ProyectoCasaVP5;
